import React, { useState } from "react";
import { useSettings } from "@/context/SettingsContext";
import { Share2, Link as LinkIcon, Check } from "lucide-react";
import { toast } from "sonner";

const ShareButtons = ({ watch }) => {
  const { settings } = useSettings();
  const [copied, setCopied] = useState(false);

  const url = typeof window !== "undefined" ? window.location.href : "";

  const shareText = `Mira este reloj personalizado de AQ Watches — ${watch.name}\n${url}`;
  const waShareLink = `https://wa.me/?text=${encodeURIComponent(shareText)}`;

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(url);
      setCopied(true);
      toast.success("Enlace copiado");
      setTimeout(() => setCopied(false), 2000);
    } catch {
      toast.error("No se pudo copiar el enlace");
    }
  };

  return (
    <div data-testid="share-section" className="pt-6 border-t border-[var(--aq-border)]">
      <div className="flex items-center gap-3 mb-4">
        <Share2 size={14} className="text-[var(--aq-muted)]" />
        <span className="overline">Compartir este reloj</span>
      </div>
      <div className="grid grid-cols-2 gap-3">
        <a
          data-testid="share-whatsapp"
          href={waShareLink}
          target="_blank"
          rel="noreferrer"
          className="inline-flex items-center justify-center gap-2 border border-[var(--aq-border)] hover:border-black px-4 py-3 text-[11px] uppercase tracking-[0.24em] transition-colors"
        >
          <svg viewBox="0 0 32 32" width="14" height="14" fill="currentColor" aria-hidden="true">
            <path d="M26.27 5.69A14.7 14.7 0 0 0 16 1.5c-8.1 0-14.69 6.59-14.69 14.7 0 2.59.68 5.12 1.97 7.34L1.5 30.5l7.18-1.74a14.66 14.66 0 0 0 7.32 1.96h.01c8.1 0 14.69-6.59 14.69-14.7 0-3.92-1.53-7.61-4.43-10.33zM16 28.05a12.13 12.13 0 0 1-6.18-1.69l-.44-.26-4.27 1.03 1.05-4.16-.29-.46a12.16 12.16 0 0 1-1.87-6.51c0-6.72 5.47-12.18 12.19-12.18A12.18 12.18 0 0 1 28.18 16c0 6.72-5.46 12.05-12.18 12.05z" />
          </svg>
          Compartir por WhatsApp
        </a>
        <button
          data-testid="share-copy"
          type="button"
          onClick={copy}
          className="inline-flex items-center justify-center gap-2 border border-[var(--aq-border)] hover:border-black px-4 py-3 text-[11px] uppercase tracking-[0.24em] transition-colors"
        >
          {copied ? <Check size={14} /> : <LinkIcon size={14} />}
          {copied ? "Copiado" : "Copiar Enlace"}
        </button>
      </div>
    </div>
  );
};

export default ShareButtons;
